import React from "react";
import { LegalLayout, H2, P, UL } from "../components/LegalLayout";
import Seo from "../components/Seo";

export default function Terms() {
    return (
        <>
            <Seo
                path="/terms"
                title="Terms and Conditions — Free AI Writers"
                description="Read the Terms and Conditions of using Free AI Writers. Acceptable use, AI-generated content ownership, limitations, and legal info."
            />
            <LegalLayout
            kicker="Legal"
            title="Terms and Conditions"
            lastUpdated="February 2026"
        >
            <P>
                Welcome to <b>Free AI Writers</b>. By accessing or using our
                website (freeaiwriters.com) and any of our 100+ free AI tools,
                you agree to be bound by these Terms and Conditions. If you do
                not agree, please do not use the site.
            </P>

            <H2>1. Use of the Service</H2>
            <P>
                Free AI Writers provides AI-powered writing, image generation,
                math, and dictionary tools — free of charge and without
                registration. You may use the tools for personal, educational,
                or commercial purposes, subject to the rules below.
            </P>

            <H2>2. Acceptable Use</H2>
            <P>You agree NOT to use the site to:</P>
            <UL>
                <li>
                    Generate illegal, hateful, harassing, defamatory, or sexually
                    explicit content involving minors
                </li>
                <li>
                    Impersonate others, spread misinformation, or commit fraud
                </li>
                <li>
                    Reverse-engineer, scrape, or attempt to overload our servers
                </li>
                <li>
                    Generate content that violates intellectual property,
                    privacy, or other rights
                </li>
                <li>Use automated bots, scripts, or crawlers without permission</li>
            </UL>

            <H2>3. AI-Generated Content</H2>
            <P>
                Outputs from our AI tools are generated by third-party language
                models (e.g. GPT-5.2, Gemini, Claude) and may contain errors,
                biases, or inaccuracies. You are solely responsible for
                reviewing, editing, and using the output. Free AI Writers makes
                <b> no guarantees</b> about accuracy, fitness for purpose, or
                originality of generated content.
            </P>

            <H2>4. Ownership of Outputs</H2>
            <P>
                You generally own the content you generate using our tools,
                subject to the terms of the underlying AI providers. We do not
                claim ownership of your outputs. You are responsible for
                ensuring your use of the output complies with applicable law and
                third-party AI provider terms.
            </P>

            <H2>5. No Professional Advice</H2>
            <P>
                Information generated by our tools — including legal, medical,
                financial, mathematical, or educational content — is for
                informational purposes only and should NOT be treated as
                professional advice. Always consult a qualified professional for
                important decisions.
            </P>

            <H2>6. Service Availability</H2>
            <P>
                We provide the site "as is" and "as available". We may modify,
                suspend, or discontinue any part of the service at any time
                without notice. We are not liable for any downtime or data loss.
            </P>

            <H2>7. Third-Party Services</H2>
            <P>
                Our site uses third-party AI providers, advertising networks
                (e.g. Ezoic), and analytics services. Use of those services is
                governed by their respective terms.
            </P>

            <H2>8. Limitation of Liability</H2>
            <P>
                To the maximum extent permitted by law, Free AI Writers, its
                operators, and partners shall not be liable for any direct,
                indirect, incidental, consequential, or punitive damages arising
                from your use of the site or its content.
            </P>

            <H2>9. Intellectual Property</H2>
            <P>
                All site design elements, branding, and original code are the
                property of Free AI Writers. You may not copy, modify, or
                redistribute these without prior written permission.
            </P>

            <H2>10. Changes to Terms</H2>
            <P>
                We may update these Terms occasionally. The "Last updated" date
                reflects the most recent change. Continued use of the site after
                changes means you accept the revised Terms.
            </P>

            <H2>11. Governing Law</H2>
            <P>
                These Terms are governed by the laws of India (or your local
                jurisdiction where applicable). Any disputes shall be resolved in
                the competent courts of that jurisdiction.
            </P>

            <H2>12. Contact</H2>
            <P>
                Questions about these Terms? Email{" "}
                <b>freeaiwriters@gmail.com</b> or visit our{" "}
                <a href="/contact" className="underline font-bold">
                    contact page
                </a>
                .
            </P>
        </LegalLayout>
        </>
    );
}
